/*
XXX_JSREFACTOR_XXX
todo @JSREFACTOR
    - write tests and refactor
*/
import { CORS } from 'root/utils/cors/cors';
import { CookieMonster } from 'root/utils/cookies/cookieMonster';
import { UserAgentDetector } from 'root/utils/userAgentDetector/userAgentDetector';
import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';
import data from 'root/core/tracking/adTrackingBlockCheck/tracking_trackers.json';
import { Lexicon } from 'root/helpers/lexicon';

const AdTrackers = function (cm) {
    this.cm = cm;
};

AdTrackers.prototype = {
    cookieName: '_lsATBC',
    fakeAdFile: '/wp-content/themes/ls/dist/js/ads.bundle.js',
    lscid: '',
    thirtyMinutes: 0.020833,

    setLSCID() {
        // We attribute a CID for the cookie value
        const COOKIEVALUE = this.cm.getCookie(this.cookieName);
        if (COOKIEVALUE) {
            this.lscid = COOKIEVALUE;
        } else {
            this.lscid =
                Math.random().toString(36).substr(2, 15) +
                Math.random().toString(36).substr(2, 15);
            this.setLSCIDCookie(this.lscid);
        }
    },

    setLSCIDCookie(lscid) {
        return this.cm.setCookie(this.cookieName, lscid, this.thirtyMinutes);
    },

    trackAds() {
        const request = new XMLHttpRequest();
        request.onreadystatechange = () => {
            if (request.readyState === 4 && request.status === 0) {
                this.postEvent('Ads', 'Blocked');
            }
        };
        request.open('GET', this.fakeAdFile);
        request.send();
    },

    checkLocation(location) {
        const currentDomain = document.body.dataset.domain; // returned as: hq, nl, be, etc
        return !!(
            location.global === true || location.target.indexOf(currentDomain) >= 0
        );
    },

    trackerCheck(tracker) {
        if (typeof window[tracker.object_name] == 'undefined') {
            this.postEvent(encodeURI(tracker.name), 'Blocked');
        }
    },

    trackTrackers() {
        const trackers = data.trackers;
        if (trackers) {
            for (let key in trackers) {
                if (
                    Object.prototype.hasOwnProperty.call(trackers, key) &&
                    this.checkLocation(trackers[key].location)
                ) {
                    this.trackerCheck(trackers[key]);
                }
            }
        }
    },

    trackCookies() {
        if (navigator.cookieEnabled === false) {
            this.postEvent('Cookies', 'Blocked');
        }
    },

    postEvent(type, status) {
        const eventData = {
            type: type,
            status: status,
            lscid: this.lscid,
        };
        CORS.xdr(
            '/rest/trackers/tracking-trackers',
            'POST',
            JSON.stringify(eventData),
            function (data) {
                console.log(data);
            },
            function (data) {
                console.log(data);
                LoggingHandler().logError(
                    'POST request to tracking-trackers endpoint has failed',
                    {
                        searchTerm: 'tracking-trackers-error',
                        fileName: 'adTrackingBlockCheck.js',
                        additionalData: {
                            eventData,
                        },
                    }
                );
            }
        );
    },

    fireTrackerChecks() {
        this.setLSCID();
        this.trackCookies();
        this.trackAds();
        this.trackTrackers();
    },

    init() {
        const ATBCCookie = this.cm.getCookie(this.cookieName);
        const UADetector = new UserAgentDetector();
        ATBCCookie === null && UADetector.isBot() === false
            ? this.fireTrackerChecks()
            : this.setLSCIDCookie(ATBCCookie);
    },
};

export default function () {
    Lexicon.get('toggle_switch/feature_toggle', lexic => {
        if (lexic.enable_tracking_trackers === 'on') {
            const cm = new CookieMonster();
            const adTrackers = new AdTrackers(cm);
            adTrackers.init();
        }
    });
}
